require('./accountBuyAmazonGiftCardView.scss');

// @vendors
const React = require('react');
const { withRouter } = require('react-router-dom');
const { connect } = require('react-redux');
const PropTypes = require('prop-types');

// @commons
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
import OKLayout from 'components/commons/OKLayout/OKLayout';
//@components
const AccountsBuyAmazonGiftCardStep1 = require('components/accounts/accountsBuyAmazonGiftCard/accountsBuyAmazonGiftCardStep1/accountsBuyAmazonGiftCardStep1');
const AccountsBuyAmazonGiftCardStep2 = require('components/accounts/accountsBuyAmazonGiftCard/accountsBuyAmazonGiftCardStep2/accountsBuyAmazonGiftCardStep2');
const AccountsBuyAmazonGiftCardSuccess = require('components/accounts/accountsBuyAmazonGiftCard/accountsBuyAmazonGiftCardSuccess/accountsBuyAmazonGiftCardSuccess');
const AccountsBuyAmazonGiftCardError = require('components/accounts/accountsBuyAmazonGiftCard/accountsBuyAmazonGiftCardError/accountsBuyAmazonGiftCardError');
const AccountsBuyAmazonGiftCardMaxLimit = require('components/accounts/accountsBuyAmazonGiftCard/accountsBuyAmazonGiftCardMaxLimit/accountsBuyAmazonGiftCardMaxLimit');
const AccountsBuyAmazonGiftCardSidebar = require('components/accounts/accountsBuyAmazonGiftCard/accountsBuyAmazonGiftCardSidebar/accountsBuyAmazonGiftCardSidebar');
const InactiveAccountsError = require('components/commons/inactiveAccountsError/inactiveAccountsError');
//utlities
const { sendTextToClipBoard } = require('commonsUtilities/clipBoardHelper');
const { hasAllAccountsInactive } = require('utilities/currentAccountsHelper');
// @helpers
const { formatText } = require('core/i18n').i18n;
// @actions
const accountBuyAmazonGiftCardActions = require('actions/accountsBuyAmazonGiftCard');
const amazonGiftCardActions = require('actions/amazonGiftCard');
const mergePreContractualsPDF = require('actions/mergePreContractualsPDF');
const preContractualMailActions = require('actions/contactCenter/preContractualMailInfo/preContractualMailInfo');
const profileActions = require('actions/profile');
const retailLoanActions = require("ok-loans/src/actions/contractRetailLoan");
// @constants
const {
    OPENYOUNG_ACCOUNT_TYPE,
    OPENYOUNG_ACCOUNT_SUBTYPE,
    EURO_TEXT,
    FIRST_STEP
} = require('constants/index');
const { WEB_INACTIVE_ACCOUNT_ENABLED } = require('constants/flagBasedFeatures');
const {
    AMAZON_GIFT_CARD_IMAGE_LOCATION_ID,
    AMAZON_GIFT_CARD_MIN_AMOUNT
} = require('constants/accountAmazonGiftCard');
import { NEGATIVE } from 'constants/layout';
const PRINT_TITLE_VALUE = 'amazonGiftCard-operativeName';
const {
    AMAZON_GIFT_CARD_HIRING_ANTERIOR,
    AMAZON_GIFT_CARD_HIRING_CANCEL,
    AMAZON_GIFT_CARD_HIRING_COMPRAR,
    AMAZON_GIFT_CARD_HIRING_REINTENTAR,
    AMAZON_GIFT_CARD_HIRING_SIGUIENTE,
    AMAZON_GIFT_CARD_HIRING_VOLVER,
    AMAZON_PROMOCIONES_CHECKBOX_CHECKED,
    AMAZON_PROMOCIONES_CHECKBOX_UNCHECKED,
    AMAZON_PROMOCIONES_STEP_ONE,
    AMAZON_PROMOCIONES_STEP_THREE_SUCCESS,
    AMAZON_PROMOCIONES_STEP_THREE,
    AMAZON_PROMOCIONES_STEP_TWO,
    AMAZON_PROMOCIONES
} = require('constants/tagging');
// @assets
const openMarketsIcon = require('assets/images/icon-openmarkets-filled.svg');
//@utils
const {
    recordLinkV2
} = require("utilities/tagging");

class AccountBuyAmazonGiftCardView extends React.Component {
    constructor(props) {
        super(props);
        this.handleFinish = this.handleFinish.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleSecondaryButtonClick = this.handleSecondaryButtonClick.bind(this);
        this.handleValidateStep = this.handleValidateStep.bind(this);
        this.handleVolverACuentasClick = this.handleVolverACuentasClick.bind(this);
        this.navigateToPromotions = this.navigateToPromotions.bind(this);
        this.resetStateOnRetry = this.resetStateOnRetry.bind(this);
        this.setVisibleSteps = this.setVisibleSteps.bind(this);
        this.onHandlePreContractCheckboxChange = this.onHandlePreContractCheckboxChange.bind(this);
        this.state = {
            isSubmitLoading: false
        }
    }

    componentDidMount() {
        this.props.getDestinationAccount();
        this.props.getAmazonGiftCardImage(AMAZON_GIFT_CARD_IMAGE_LOCATION_ID);
        this.props.getAmazonCouponCodeInfo();
    }

    componentWillUnmount() {
        const {
            resetErrorStatus,
            resetPrecontractualMail,
            resetState,
        } = this.props;
        resetErrorStatus();
        resetState();

        if (__CONTACT_CENTER__) {
            resetPrecontractualMail();
        }
    }

    handleRecordLink(categoriaEvento, accionEvento) {
        const customData = ({
            categoriaEvento,
            accionEvento
        });
        recordLinkV2(customData);
    }

    handleCancel() {
        this.props.history.push('/myprofile/accounts');
    }

    handleFinish() {
        const { getConsentStatus, getAmazonGiftCard } = this.props;
        if (!__CONTACT_CENTER__) {
            this.setState({ isSubmitLoading: true });
            const successCallback = response => {
                this.setState({ isSubmitLoading: false });
                const amazonConsent = (response.find(consent => consent.consentCell.id === '02') || {}).status;
                if (amazonConsent === 'ACCEPTED') {
                    getAmazonGiftCard();
                }
            };
            getConsentStatus(successCallback)
        } else {
            getAmazonGiftCard();
        }
        this.handleRecordLink(AMAZON_PROMOCIONES_STEP_TWO, AMAZON_GIFT_CARD_HIRING_COMPRAR);
    }

    resetStateOnRetry() {
        const {
            getAmazonCouponCodeInfo,
            getAmazonGiftCardImage,
            getDestinationAccount,
            resetErrorStatus,
            resetState,
        } = this.props;
        resetErrorStatus();
        resetState();
        getDestinationAccount();
        getAmazonGiftCardImage(AMAZON_GIFT_CARD_IMAGE_LOCATION_ID);
        getAmazonCouponCodeInfo();
        this.handleRecordLink(AMAZON_PROMOCIONES_STEP_THREE, AMAZON_GIFT_CARD_HIRING_REINTENTAR);
    }

    filterAccounts() {
        const { immAccounts } = this.props;
        const accountsIndexes = immAccounts.get('byOrder').filter(accountId =>
            // We remove the accounts that are not in euros
            immAccounts.getIn(['byId', accountId, 'balance', 'currency']) === EURO_TEXT
        ).filter(accountId =>
        // We remove the open young saving account
        (immAccounts.getIn(['byId', accountId, 'newProduct']) !== OPENYOUNG_ACCOUNT_TYPE ||
            immAccounts.getIn(['byId', accountId, 'accountType']) !== OPENYOUNG_ACCOUNT_SUBTYPE)
        );
        // We return an array with the ids of the filtered accounts
        return accountsIndexes.toJS();
    }

    onHandlePreContractCheckboxChange(evt) {
        const { handlePreContractCheckboxChange } = this.props;
        handlePreContractCheckboxChange(evt.target.checked);

        const customData = ({
            categoriaEvento: AMAZON_PROMOCIONES_STEP_TWO,
            accionEvento: "clickCheckBox",
            etiquetaEvento: evt.target.checked ? AMAZON_PROMOCIONES_CHECKBOX_CHECKED : AMAZON_PROMOCIONES_CHECKBOX_UNCHECKED
        });
        recordLinkV2(customData);
    }

    handleValidateStep(step) {
        const { amazonGiftCards, validateStep } = this.props;
        this.handleRecordLink(AMAZON_PROMOCIONES_STEP_ONE, AMAZON_GIFT_CARD_HIRING_SIGUIENTE);
        validateStep(step, amazonGiftCards.get('remainingBalance'));
    }

    setVisibleSteps(step) {
        const { setVisibleStep } = this.props;
        this.handleRecordLink(AMAZON_PROMOCIONES_STEP_TWO, AMAZON_GIFT_CARD_HIRING_ANTERIOR);
        setVisibleStep(step);
    }

    buildWizard() {
        const {
            accountBuyAmazonGiftCard,
            amazonGiftCards,
            handleAgreementCheckboxChange,
            immAccounts,
            immFlagBasedFeatures,
            immGlobalVariables,
            immPdfData,
            immPreContractualMail,
            immProfile,
            match: { params: { accountId } },
            requestPDFMerge,
            requestProfile,
            sendPreContractualMail,
            setAccount,
            setAccountAvailableBalance,
            setAmount,
            setGiftVoucherAmount,
            setWillCancel
        } = this.props;
        const immSteps = accountBuyAmazonGiftCard.get('steps');
        const initialAccount = immAccounts.getIn(['byId', accountId]);
        const visibleStep = accountBuyAmazonGiftCard.get('visibleStep');
        const accountsById = immAccounts.get('byId');
        const accountsList = this.filterAccounts();
        const promotionalPercentage = immGlobalVariables.getIn(['variables', 'parameters', 'amazon_gift_cards_promotional_percentage', 'value']) || '';
        const printTitleValue = __CONTACT_CENTER__ && PRINT_TITLE_VALUE;

        const categoriaEvento = visibleStep && `${AMAZON_PROMOCIONES}/paso ${visibleStep}`
        const tealiumForCancel = visibleStep
            ? {
                accionEvento: "cancelar",
                categoriaEvento: categoriaEvento
            } : null;

        const actions = {
            validateStep: this.handleValidateStep,
            setWillCancel: setWillCancel,
            setVisibleStep: this.setVisibleSteps,
            finish: this.handleFinish,
            cancel: this.handleCancel
        };

        return (
            <Wizard
                actions={actions}
                immSteps={immSteps}
                stepsAmount={immSteps.size}
                visibleStep={visibleStep}
                showPreLeaveModal={true}
                tealiumForCancel={tealiumForCancel}
                isTaggingSecondVersion
            >
                <WizardStep
                    position="first"
                    cancelButton={true}
                >
                    <AccountsBuyAmazonGiftCardStep1
                        accountBuyAmazonGiftCard={accountBuyAmazonGiftCard}
                        accountsIndexes={accountsList}
                        amazonGiftCards={amazonGiftCards}
                        handleAgreementCheckboxChange={handleAgreementCheckboxChange}
                        immAccounts={accountsById}
                        immPreContractualMail={immPreContractualMail}
                        immProfile={immProfile}
                        immStep={immSteps.get(FIRST_STEP)}
                        isInactiveAccountsEnabled={immFlagBasedFeatures.get(WEB_INACTIVE_ACCOUNT_ENABLED)}
                        promotionalPercentage={promotionalPercentage}
                        requestProfile={requestProfile}
                        sendPreContractualMail={sendPreContractualMail}
                        setAccount={setAccount}
                        setAccountAvailableBalance={setAccountAvailableBalance}
                        setAmount={setAmount}
                        initialAccount={initialAccount}
                        setGiftVoucherAmount={setGiftVoucherAmount}
                    />
                </WizardStep>
                <WizardStep
                    addLoadingBehaviour={true}
                    isLoading={this.state.isSubmitLoading}
                    position="last"
                    cancelButton={true}
                    immFinalButton="buyAmazonGiftCard-finalButton"
                >
                    <AccountsBuyAmazonGiftCardStep2
                        accountBuyAmazonGiftCard={accountBuyAmazonGiftCard}
                        handlePreContractCheckboxChange={this.onHandlePreContractCheckboxChange}
                        immAccounts={immAccounts}
                        immPdfData={immPdfData}
                        immProfile={immProfile}
                        immSteps={immSteps}
                        printTitleValue={printTitleValue}
                        requestPDFMerge={requestPDFMerge}
                    />
                </WizardStep>
            </Wizard>

        );
    }

    buildTooltipContent(iban) {
        return (
            <span>
                {iban}
                <button
                    className="icon__tooltip icon-copiar"
                    onClick={() => sendTextToClipBoard(iban)}>
                </button>
            </span>
        );
    }

    navigateToPromotions() {
        this.handleRecordLink(AMAZON_PROMOCIONES_STEP_THREE, AMAZON_GIFT_CARD_HIRING_REINTENTAR);
        this.props.history.goBack();
    }

    handleVolverACuentasClick() {
        const linkToAccounts = `/myprofile/accounts`;
        this.handleRecordLink(AMAZON_PROMOCIONES_STEP_THREE_SUCCESS, AMAZON_GIFT_CARD_HIRING_VOLVER);
        this.props.history.push(linkToAccounts);
    }

    handleSecondaryButtonClick() {
        const cancelLink = '/myprofile/accounts';
        this.handleRecordLink(AMAZON_PROMOCIONES_STEP_THREE, AMAZON_GIFT_CARD_HIRING_CANCEL);
        this.props.history.push(cancelLink);
    }

    render() {
        const {
            accountBuyAmazonGiftCard,
            amazonGiftCards,
            immAccounts,
            immRetailLoan,
            match: { params: { accountId } },
            showNotification
        } = this.props;
        const immSteps = accountBuyAmazonGiftCard.get('steps');
        const commonPath = '/myprofile/accounts';
        let immAccount;
        let mappingBreadcrumb;
        const selectedAccountId = !!immSteps.getIn([FIRST_STEP, 'accountSelected']) ? immSteps.getIn([FIRST_STEP, 'accountSelected']) : accountId;
        immAccount = immAccounts.getIn(['byId', selectedAccountId]);
        if (!!accountId) {
            mappingBreadcrumb = [{
                text: formatText('breadcrumb-accounts'),
                url: commonPath
            }, {
                text: immAccount.get('alias'),
                url: `${commonPath}/${selectedAccountId}/movements`
            },
            {
                text: formatText('breadcrumb-amazonGiftCard'),
                url: ''
            }];
        } else {
            mappingBreadcrumb = [{
                text: formatText('breadcrumb-amazonGiftCard'),
                url: ''
            }];
        }
        const allAccountsInactive = hasAllAccountsInactive(
            immAccounts.get('byOrder'),
            immAccounts.get('byId')
        );
        const headerIcon = (
            <img src={openMarketsIcon} className="openmarkets-icon" />
        );
        let bodyBlock;
        const consentStatus = immRetailLoan.get('acceptAmazonConsentsStatus');
        const hasErrorGettingConsentsStatus = immRetailLoan.get('hasErrorConsentsStatus');
        const isGenericError = accountBuyAmazonGiftCard.get('submitError') ||
            accountBuyAmazonGiftCard.get('error') ||
            hasErrorGettingConsentsStatus;

        if (allAccountsInactive) {
            bodyBlock = (<InactiveAccountsError
                navigateToBackButtonText={'accounts'}
                navigateToBackButtonURL={'accounts'}
            />);
        } else if (amazonGiftCards.get('remainingBalance') < AMAZON_GIFT_CARD_MIN_AMOUNT) {
            bodyBlock = (<AccountsBuyAmazonGiftCardMaxLimit
                handleCancelClick={this.handleSecondaryButtonClick}
                handleRetryClick={this.navigateToPromotions}
            />);
        } else if (isGenericError) {
            bodyBlock = (<AccountsBuyAmazonGiftCardError
                title={'buyAmazonGiftCardError-title'}
                content={'buyAmazonGiftCardError-content'}
                handleRetryClick={this.resetStateOnRetry}
                handleCancelClick={this.handleSecondaryButtonClick}
            />);
        } else if (accountBuyAmazonGiftCard.get('submitSuccessful')) {
            bodyBlock = (<AccountsBuyAmazonGiftCardSuccess
                immSteps={immSteps}
                accountBuyAmazonGiftCard={accountBuyAmazonGiftCard}
                immAccounts={immAccounts}
                handleVolverACuentasClick={this.handleVolverACuentasClick}
                showNotification={showNotification}
            />)
        } else if (!__CONTACT_CENTER__ && consentStatus && (consentStatus !== 'ACCEPTED')) {
            bodyBlock = (
                <AccountsBuyAmazonGiftCardError
                    showCancelButton={false}
                    showHelpText={false}
                    title={'buyAmazonGiftCardError-title'}
                    content={'buyAmazonGiftCardError-consentError'}
                    handleRetryClick={this.navigateToPromotions}
                    handleCancelClick={this.handleSecondaryButtonClick}
                />
            );
        } else {
            bodyBlock = (
                <div className="row">
                    <div className="col-md-12 col-lg-8">
                        {this.buildWizard()}
                    </div>
                    <div className="hidden-xs hidden-sm hidden-md col-lg-4">
                        <AccountsBuyAmazonGiftCardSidebar
                            immSteps={immSteps}
                            immAccounts={immAccounts}
                            accountBuyAmazonGiftCard={accountBuyAmazonGiftCard}
                        />
                    </div>
                </div>
            );
        }

        return (
            <div className="accounts-buy-amazon-gift-card-view">
                <OKLayout
                    breadcrumb={mappingBreadcrumb}
                    title={formatText('buyAmazonGiftCard-pageTitle')}
                    section="accounts"
                    contentPosition={NEGATIVE}
                    buttons={headerIcon}
                >
                    {bodyBlock}
                </OKLayout>
            </div>
        );

    }
}

AccountBuyAmazonGiftCardView.propTypes = {
    accountBuyAmazonGiftCard: PropTypes.object.isRequired,
    amazonGiftCards: PropTypes.object.isRequired,
    getAmazonCouponCodeInfo: PropTypes.func,
    getAmazonGiftCard: PropTypes.func,
    getAmazonGiftCardImage: PropTypes.func,
    getConsentStatus: PropTypes.func,
    getDestinationAccount: PropTypes.func,
    handleAgreementCheckboxChange: PropTypes.func.isRequired,
    handlePreContractCheckboxChange: PropTypes.func,
    history: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immGlobalVariables: PropTypes.object.isRequired,
    immPdfData: PropTypes.object,
    immPreContractualMail: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    immRetailLoan: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    requestPDFMerge: PropTypes.func,
    requestProfile: PropTypes.func.isRequired,
    resetPrecontractualMail: PropTypes.func.isRequired,
    resetErrorStatus: PropTypes.func.isRequired,
    resetState: PropTypes.func,
    sendPreContractualMail: PropTypes.func.isRequired,
    setAccount: PropTypes.func,
    setAccountAvailableBalance: PropTypes.func,
    setAmount: PropTypes.func,
    setGiftVoucherAmount: PropTypes.func,
    setVisibleStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    showNotification: PropTypes.func,
    validateStep: PropTypes.func.isRequired,
};

module.exports.constructor = AccountBuyAmazonGiftCardView;
module.exports.AccountBuyAmazonGiftCardView = connect(
    state => ({
        accountBuyAmazonGiftCard: state.accountsBuyAmazonGiftCard,
        amazonGiftCards: state.amazonGiftCards,
        immAccounts: state.accounts,
        immFlagBasedFeatures: state.flagBasedFeatures,
        immGlobalVariables: state.globalVariables,
        immPdfData: state.precontractualsMergePdfs,
        immPreContractualMail: state.preContractualMail,
        immProfile: state.profile,
        immRetailLoan: state.contractRetailLoan,
    }), {
    getAmazonCouponCodeInfo: amazonGiftCardActions.getAmazonCouponCodeInfo,
    getAmazonGiftCard: accountBuyAmazonGiftCardActions.getAmazonGiftCard,
    getAmazonGiftCardImage: accountBuyAmazonGiftCardActions.getAmazonGiftCardImage,
    getConsentStatus: retailLoanActions.getConsentStatus,
    getDestinationAccount: accountBuyAmazonGiftCardActions.getDestinationAccount,
    handleAgreementCheckboxChange: accountBuyAmazonGiftCardActions.setAgreementCheckbox,
    handlePreContractCheckboxChange: accountBuyAmazonGiftCardActions.setAmazonGiftCardPreContractCheckbox,
    requestPDFMerge: mergePreContractualsPDF.requestPDFMerge,
    requestProfile: profileActions.requestProfile,
    resetErrorStatus: retailLoanActions.simpleActions.retailLoanResetErrorsStatus,
    resetPrecontractualMail: preContractualMailActions.resetPrecontractualMail,
    resetState: accountBuyAmazonGiftCardActions.resetState,
    sendPreContractualMail: preContractualMailActions.sendAmazonGiftCardPrecontractualMail,
    setAccount: accountBuyAmazonGiftCardActions.setAccount,
    setAccountAvailableBalance: accountBuyAmazonGiftCardActions.setAccountAvailableBalance,
    setAmount: accountBuyAmazonGiftCardActions.setAmount,
    setGiftVoucherAmount: accountBuyAmazonGiftCardActions.setGiftVoucherAmount,
    setVisibleStep: accountBuyAmazonGiftCardActions.setVisibleStep,
    setWillCancel: accountBuyAmazonGiftCardActions.setWillCancel,
    showNotification: amazonGiftCardActions.showNotification,
    validateStep: accountBuyAmazonGiftCardActions.validateStep,
})(withRouter(AccountBuyAmazonGiftCardView));
